import { useAtom } from "jotai";
import { useCallback, useMemo } from "react";

import { remindMeAtom } from "../../widget.state";
import { OptionType } from "../../widget.types";

import { QuestionButton } from "./question-button.component";

export function OptInReminder({
  isQuestionAnswered,
}: {
  isQuestionAnswered?: boolean;
}) {
  const [remindMe, setRemindMe] = useAtom(remindMeAtom);

  const onReminderClick = useCallback(
    (reminderOption: boolean) => {
      if (!isQuestionAnswered) return;
      setRemindMe(reminderOption);
    },
    [setRemindMe, isQuestionAnswered]
  );

  const reminderButtons: OptionType[] = useMemo(() => {
    return [
      {
        id: "true",
        title: "Yes, remind me please",
        isCorrect: true,
        isSelected: remindMe !== null && remindMe,
      },
      {
        id: "false",
        title: "No, thanks",
        isCorrect: false,
        isSelected: remindMe !== null && !remindMe,
      },
    ];
  }, [remindMe]);

  return (
    <div className="quiz--single-page__body__question__reminder">
      <div className="quiz--single-page__body__question__reminder__message">
        Would you like to receive a reminder email when you are eligible to
        re-enter the sweeps?
      </div>
      <div className="quiz__buttons quiz--single-page__body__question__reminder__options">
        {reminderButtons.map((option) => (
          <QuestionButton
            key={option.id}
            isSelected={option.isSelected}
            isCorrect={option.isCorrect}
            isSms={false}
            isCpl={false}
            isReminder={true}
            isDisabled={!isQuestionAnswered}
            onClick={() => onReminderClick(Boolean(JSON.parse(option.id)))}
          >
            {option.title}
          </QuestionButton>
        ))}
      </div>
    </div>
  );
}
